__turbopack_context__.v({
  "fieldbox": "fieldset-module-scss-module__u5P-DG__fieldbox",
  "fields": "fieldset-module-scss-module__u5P-DG__fields",
  "fieldset": "fieldset-module-scss-module__u5P-DG__fieldset",
  "visual": "fieldset-module-scss-module__u5P-DG__visual",
});
